import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { loadMathPicker } from "../picker/math-module";

import { bindLynxWindowContribution } from "../window/contributions/lynx-contribution";

import { bindLynxCanvasModules } from "../canvas/contributions/lynx/modules";

import { LynxEnvContribution } from "./contributions/lynx-contribution";

export function bindLynxEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, LynxEnvContribution)) || (container.bind(LynxEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(LynxEnvContribution));
}

export function loadLynxEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadLynxEnv.__loaded || (loadLynxEnv.__loaded = !0, bindLynxEnv(container), bindLynxCanvasModules(container), 
    bindLynxWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadLynxEnv.__loaded = !1;

export function initLynxEnv() {
    loadLynxEnv();
}
//# sourceMappingURL=lynx.js.map